export default __webpack_public_path__ + "static/media/logo-Global-Net.f971276b.png";